import { actions } from './action'

const initialState = {
  locationsData: [],
  totalCount: 0,
  pagination: {
    skip: 0,
    limit: 10,
  },
}

const location = (state = initialState, action) => {
  switch (action.type) {
    case actions.GET_LOCATIONS_DATA:
      return {
        ...state,
        locationsData: action.payload.locationList,
        totalCount: action.payload.totalCount,
      }
    case actions.HANDLE_PAGINATION:
      return {
        ...state,
        pagination: action.payload,
      }
    default:
      return state
  }
}

export default location
